import { Skeleton } from '../Skeleton';

export function AdminDashboardSkeleton() {
  return (
    <div className="max-w-5xl">
      <div className="mb-8">
        <Skeleton className="h-8 w-64 mb-2" />
        <Skeleton className="h-4 w-80" />
      </div>

      <Skeleton className="h-20 w-full mb-8" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="p-6 bg-white border border-gray-200 rounded-xl"
          >
            <div className="flex items-center gap-3 mb-3">
              <Skeleton className="w-9 h-9" />
              <Skeleton className="h-4 w-24" />
            </div>
            <Skeleton className="h-8 w-16" />
          </div>
        ))}
      </div>
    </div>
  );
}
